import {css} from 'styled-components';

import {toReadonly} from '../../../core/src/helpers/typescript/typeHelpers';
import {boxShadow} from '../theme/themeStyleHelpers';
import {alphas} from './colorStyles';

/*
 * Shadows.
 */

/** Standard shadows. */
export const shadows = toReadonly({
  avatar: css`
    box-shadow: inset 0 0 0 1px ${(p) => p.theme.border.alpha};
  `,
  tooltip: css`
    ${(p) =>
      boxShadow(p.theme, `0 2px 4px rgba(0, 0, 0, 0.2)`, `outline: 1px solid ${p.theme.tooltip.border}`)};
  `,
  dialogsAndDropdowns: css`
    ${(p) =>
      boxShadow(
        p.theme,
        `0 0 1px ${alphas.black50}, 0 3px 10px ${alphas.black30}`,
        // In dark mode, an inset box shadow is used to create the border effect.
        // We specifically do not use a border because some components (e.g. Dropdown)
        // rely on pixel height/width dimensions being passed in. Changing the box model
        // values by setting a border can cause unexpected behavior.
        // See https://front.atlassian.net/browse/PB-39772
        `box-shadow: inset 0 0 0 1px ${p.theme.greys.shade30}`,
      )};
  `,
  synopsis: css`
    ${(p) =>
      boxShadow(
        p.theme,
        `0 0 1px ${alphas.black60}, 0 3px 10px ${alphas.black40}`,
        // In dark mode, an inset box shadow is used to create the border effect.
        // We specifically do not use a border because some components (e.g. Dropdown)
        // rely on pixel height/width dimensions being passed in. Changing the box model
        // values by setting a border can cause unexpected behavior.
        // See https://front.atlassian.net/browse/PB-39772
        `box-shadow: inset 0 0 0 1px ${p.theme.greys.shade30}`,
      )};
  `,
  redesignedSynopsis: css`
    ${(p) =>
      boxShadow(p.theme, `0 0 0px 1px ${p.theme.border.tertiary}, 0 3px 10px ${p.theme.alphas.black50}`)};
  `,
  searchModal: css`
    ${(p) =>
      boxShadow(
        p.theme,
        `0 0 1px ${alphas.black50}, 0 4px 48px rgba(0,0,0,.2)`,
        // In dark mode, an inset box shadow is used to create the border effect.
        // We specifically do not use a border because some components (e.g. Dropdown)
        // rely on pixel height/width dimensions being passed in. Changing the box model
        // values by setting a border can cause unexpected behavior.
        // See https://front.atlassian.net/browse/PB-39772
        `box-shadow: inset 0 0 0 1px ${p.theme.greys.shade30}, 0 4px 48px rgba(0,0,0,.2)`,
      )};
  `,
  settingsCopilotButton: css`
    ${(p) =>
      boxShadow(p.theme, `0 80px 100px 0 ${p.theme.greys.shade40}, 0 3px 5px 0 ${p.theme.greys.shade30}`)};
  `,
  sidePanel: css`
    ${(p) => boxShadow(p.theme, `0px 3px 10px rgba(0, 0, 0, 0.08)`)};
  `,
});
